import { ExtensionsPaths } from "../../urls";

export const PLACEHOLDER_MANIFEST_URL = "https://example.com/api/manifest";

export const EL_ID_MANIFEST_INPUT_LABEL = "manifest-input-label";

export const previousPagePath = ExtensionsPaths.installedExtensions;
